const SET_COMMON_ERROR = "SET_COMMON_ERROR"

export 
{
    SET_COMMON_ERROR
}